import React, { useState, useEffect, useCallback } from 'react';
import ImageGallery from 'react-image-gallery';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'styles/jss/original/components/shoppings/detailImage';
import dummyImage from 'public/img/ui/loading-dummy.gif';
import { IShopping } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  shopping: IShopping;
  isSp: boolean;
};

const DetailImage: React.FC<ComponentProps> = ({ shopping, isSp }) => {
  const { mainImage, gallery } = shopping.fields;
  const [loaded, setLoaded] = useState(false);
  const classes = useStyles();
  const getImageUrl = useCallback(
    (url: string) => {
      if (isSp) {
        return `${url}?fm=webp&fit=pad&w=800`;
      } else {
        return `${url}?fm=webp`;
      }
    },
    [isSp]
  );
  useEffect(() => {
    setLoaded(false);
    const img = new Image();
    img.src = getImageUrl(mainImage.fields.file.url);
    img.onload = () => {
      setLoaded(true);
    };
  }, [getImageUrl, mainImage]);
  const images = gallery
    ? gallery.map((item) => {
        const imageUrlGalleryItem = getImageUrl(item.fields.file.url);
        return { original: imageUrlGalleryItem, thumbnail: imageUrlGalleryItem };
      })
    : [
        {
          original: getImageUrl(mainImage.fields.file.url),
          thumbnail: getImageUrl(mainImage.fields.file.url)
        }
      ];
  const showThumbnail = images.length > 1;

  return (
    <div className={classes.section}>
      <div className={classes.imageGalleryWrapper}>
        {loaded ? (
          <ImageGallery
            showFullscreenButton={false}
            showPlayButton={false}
            showThumbnails={showThumbnail}
            items={images}
          />
        ) : (
          <img src={dummyImage} alt='ローディング中' className={classes.imgLoading} />
        )}
      </div>
    </div>
  );
};

export default DetailImage;
